import { Component, type ReactNode } from "react";

const FLAG = "caint-auto-recuperado";

/**
 * Rede de segurança contra "tela branca": se o app quebrar ao renderizar
 * (ex.: estado persistido incompatível após uma atualização), limpa o estado
 * salvo (`caint*` no localStorage) e recarrega UMA vez. Se ainda assim quebrar,
 * mostra uma mensagem com botão — sem loop de reload.
 */
export class ErroBoundary extends Component<{ children: ReactNode }, { erro: boolean }> {
  override state = { erro: false };

  static getDerivedStateFromError(): { erro: boolean } {
    return { erro: true };
  }

  override componentDidCatch() {
    if (typeof window === "undefined") {
      return;
    }
    if (!sessionStorage.getItem(FLAG)) {
      sessionStorage.setItem(FLAG, "1");
      try {
        for (const chave of Object.keys(localStorage)) {
          if (chave.startsWith("caint")) {
            localStorage.removeItem(chave);
          }
        }
      } catch {
        // localStorage indisponível — segue para o reload mesmo assim
      }
      window.location.reload();
    }
  }

  override render() {
    if (!this.state.erro) {
      return this.props.children;
    }
    const jaTentou = typeof window !== "undefined" && sessionStorage.getItem(FLAG);
    if (!jaTentou) {
      return null; // recuperando (reload em andamento)
    }
    return (
      <div
        style={{
          minHeight: "100dvh",
          display: "grid",
          placeItems: "center",
          padding: 24,
          textAlign: "center",
          fontFamily: "system-ui, sans-serif",
          color: "#2a2e4b",
          background: "#f6f6fb",
        }}
      >
        <div style={{ maxWidth: 320 }}>
          <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 8 }}>Algo deu errado</div>
          <p style={{ fontSize: 14, lineHeight: 1.5, color: "#585f73", marginBottom: 16 }}>
            Não foi possível carregar o app. Toque em recarregar; se persistir, feche e reabra.
          </p>
          <button
            type="button"
            style={{
              padding: "10px 18px",
              borderRadius: 10,
              border: "none",
              background: "#585fa0",
              color: "#fff",
              fontWeight: 700,
              cursor: "pointer",
            }}
            onClick={() => {
              sessionStorage.removeItem(FLAG);
              window.location.reload();
            }}
          >
            Recarregar
          </button>
        </div>
      </div>
    );
  }
}
